// all api

import axios from 'axios';

const API_BASE_URL = 'https://portfolio-server-five-omega.vercel.app';



export const likeBlog = async (blogId) => {
  try {
    await axios.post(`${API_BASE_URL}/blogs/${blogId}/like`);
    console.log('Like count updated successfully');
  } catch (error) {
    console.error('Failed to update like count:', error.response.data.message);
  }
};

export const dislikeBlog = async (blogId) => {
  try {
    await axios.post(`${API_BASE_URL}/blogs/${blogId}/dislike`);
    console.log('Dislike count updated successfully');
  } catch (error) {
    console.error('Failed to update dislike count:', error.response.data.message);
  }
};





export const searchBlogs = async (query, page, limit) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/search`, {
      params: { query, page, limit },
    });
    return response.data;
  } catch (error) {
    throw new Error('Failed to search blogs');
  }
};

export const getPaginatedBlogs = async (page, limit) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/pagination`, {
      params: { page, limit },
    });
    return response.data;
  } catch (error) {
    throw new Error('Failed to fetch paginated blogs');
  }
};












export const fetchProjects = async () => {
    const response = await fetch(`${API_BASE_URL}/project`);
    if (!response.ok) {
      throw new Error('Failed to fetch data');
    }
    const data = await response.json();
    // console.log(data)
    return data;
  };

  
  export const addProject = async (projectData) => {
    const response = await fetch(`${API_BASE_URL}/project`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(projectData),
    });
  
    if (!response.ok) {
      throw new Error('Failed to create project');
    }
  
    const data = await response.json();
    return data;
  };
  

  export const deleteProject = async (projectId) => {
    const response = await fetch(`${API_BASE_URL}/project/${projectId}`, {
      method: 'DELETE',
    });
  
    if (!response.ok) {
      throw new Error('Failed to delete the project');
    }
  };
  


  // api.js
export const updateProject = async (projectId, updatedProjectData) => {
  const response = await fetch(`${API_BASE_URL}/project/${projectId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(updatedProjectData),
  });

  if (!response.ok) {
    throw new Error('Failed to update the project');
  }

  const data = await response.json();
  return data;
};




export const fetchBlogs = async (searchQuery, page, limit) => {
  const searchURL = `${API_BASE_URL}/blog/search?query=${searchQuery}&page=${page}&limit=${limit}`;
  const paginationURL = `${API_BASE_URL}/pagination?page=${page}&limit=${limit}`;

  const url = searchQuery ? searchURL : paginationURL;

  const response = await fetch(url);
  if (!response.ok) {
    throw new Error('Failed to fetch blogs');
  }
  const data = await response.json();
  return data;
};





export const addBlog = async (blogData) => {
  const response = await fetch(`${API_BASE_URL}/blog`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(blogData),
  });

  if (!response.ok) {
    throw new Error('Failed to create blog');
  }

  const data = await response.json();
  return data;
};

export const deleteBlog = async (blogId) => {
  const response = await fetch(`${API_BASE_URL}/blog/${blogId}`, {
    method: 'DELETE',
  });

  if (!response.ok) {
    throw new Error('Failed to delete the blog');
  }
};

export const updateBlog = async (blogId, updatedBlogData) => {
  const response = await fetch(`${API_BASE_URL}/blog/${blogId}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(updatedBlogData),
  });

  if (!response.ok) {
    throw new Error('Failed to update the blog');
  }

  const data = await response.json();
  return data;
};

export const fetchBlogById = async (blogId) => {
  const response = await fetch(`${API_BASE_URL}/blog/${blogId}`);
  if (!response.ok) {
    throw new Error('Failed to fetch blog');
  }
  const data = await response.json();
  return data;
};


export const createComment = async (newComment) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/comments`, { content: newComment });
    return response.data;
  } catch (error) {
    throw new Error('Failed to create comment');
  }
};

export const getComments = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/comments`);
    return response.data;
  } catch (error) {
    throw new Error('Failed to fetch comments');
  }
};


export const submitFeedback = async (feedbackData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/feedback`, feedbackData);
    return response.data;
  } catch (error) {
    throw new Error('Failed to submit feedback');
  }
};

export const getFeedback = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/feedback`);
    return response.data;
  } catch (error) {
    throw new Error('Failed to fetch feedback');
  }
};

export const verifyAdmin = async (token) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/verify-admin`, { token });
    return response.data.isAdmin;
  } catch (error) {
    console.error('Error verifying admin:', error);
    return false;
  }
};